var _path, _path2, _path3, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFairdropLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.04 113.39",
    enableBackground: "new 0 0 85.04 113.39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.637,47.782h-4.761V28.598c0-4.474,1.1-8.928,3.183-12.88l4.212,2.219 c-1.747,3.318-2.634,6.905-2.634,10.661V47.782z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M67.483,47.879h-4.762V28.595c0-12.704-10.335-23.041-23.042-23.041c-8.566,0-16.387,4.744-20.409,12.379 l-4.212-2.219C19.907,6.51,29.341,0.794,39.68,0.794c15.331,0,27.803,12.472,27.803,27.801V47.879z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.649,112.84c-21.432,0-38.867-17.438-38.867-38.869c0-21.429,17.435-38.864,38.867-38.864 c9.261,0,18.233,3.311,25.261,9.325l-3.098,3.619c-6.166-5.277-14.037-8.183-22.164-8.183c-18.806,0-34.104,15.3-34.104,34.104 c0,18.807,15.298,34.106,34.104,34.106c18.805,0,34.105-15.3,34.105-34.106c0-2.166-0.205-4.33-0.605-6.441l4.678-0.892 c0.458,2.402,0.689,4.871,0.689,7.333C78.516,95.402,61.078,112.84,39.649,112.84z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "37.507,87.562 20.633,67.928 24.244,64.825 37.992,80.823 80.732,43.558 83.862,47.148 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairdropLock);
export default __webpack_public_path__ + "static/media/fairdrop-lock.2ca737cd.svg";
export { ForwardRef as ReactComponent };